import { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import pDebounce from 'p-debounce'

import { useApi } from '../../components/ApiProvider'
import createPromiseLinearizer from '../createPromiseLinearizer'

export function useProductSuggestedSearch(query?: string, shouldFetch = true): Core.SuggestedSearchProduct[] {
  const api = useApi()
  const locale = useSelector<State>((state) => state.getIn(['shop', 'locale']))
  const [result, setResult] = useState<Core.SuggestedSearchProduct[]>([])
  const linearizer = useRef(createPromiseLinearizer<Core.SuggestedSearchProduct[]>())

  const send = useMemo(
    () =>
      pDebounce(
        (query?: string) =>
          linearizer.current(() =>
            api
              .get<Core.SuggestedSearchProduct[]>('/api/v2/suggestedSearch', {
                params: {
                  q: query,
                  limit: 50,
                  sort: 'createdAt-desc',
                  locale,
                },
              })
              .then((result) => result.data),
          ),
        200,
      ),
    [api, locale],
  )

  useEffect(() => {
    let subscribed = true
    if (!shouldFetch || query === undefined) {
      setResult([])
    } else {
      send(query)
        .then((res) => {
          if (subscribed) {
            setResult(res)
          }
        })
        .catch()
    }
    return () => {
      subscribed = false
    }
  }, [query, send, shouldFetch])

  return result
}
